<mat-card *ngIf="licenseInfo"
          [class.usage-card-small]="size === 'small'"
          [class.usage-card-large]="size === 'large'">
    <mat-card-header>
        <mat-card-title class="counter count-color layout-row layout-align-h-center">
            {{ licenseInfo?.translationKey(license) | translate }}
        </mat-card-title>
        <mat-card-subtitle>
            <ui-license-usage-subtitle [used]="license?.used[licenseInfo.key]"
                                       [available]="license?.allowed[licenseInfo.key]"
                                       [consumerType]="licenseInfo?.consumerType(license)">
            </ui-license-usage-subtitle>
        </mat-card-subtitle>
    </mat-card-header>

    <div class="percentage-container"
         [class.filling-soon]="license?.totals[licenseInfo.key] >= warningLevels['filling-soon']"
         [class.filling-imminent]="license?.totals[licenseInfo.key] >= warningLevels['filling-imminent']">
        <mat-progress-spinner [value]="100"
                              [diameter]="diameter"
                              [strokeWidth]="diameter / 16"
                              color="primary"
                              class="background-spinner">
        </mat-progress-spinner>
        <mat-progress-spinner [value]="license?.totals[licenseInfo.key]"
                              [diameter]="diameter"
                              [strokeWidth]="diameter / 16"
                              color="primary"
                              class="filled-license">
        </mat-progress-spinner>
        <span class="percentage">
            <span>{{ license?.totals[licenseInfo.key] }}%</span>
        </span>
    </div>

    <mat-card-content *ngIf="size === 'large'">
        <mat-divider></mat-divider>
        <p class="license-description">
            <ng-container *ngIf="license[licenseInfo.key + 'Concurrent']; else nonConcurrent">
                {{ licenseInfo?.descriptionConcurrentTag | translate }}
            </ng-container>
            <ng-template #nonConcurrent>
                {{ licenseInfo?.descriptionTag | translate }}
            </ng-template>
        </p>
    </mat-card-content>

    <mat-card-actions *ngIf="!isHost">
        <a [routerLink]="['/license', licenseInfo.url]"
           mat-button
           color="primary">
            {{ 'license_action_see_more' | translate }}
        </a>
    </mat-card-actions>
</mat-card>
